var map = {
	"./2svgTESTI.svg": "8653",
	"./CBdac.png": "2b1d",
	"./CBsuomenakatemia.png": "4472",
	"./CBsyke.png": "c589",
	"./CBtuni.png": "e165",
	"./CBvtt-new.png": "15b0",
	"./CBvtt.png": "ac91",
	"./DAC_logo.png": "17b6",
	"./DAC_logo_grey.png": "0900",
	"./STN_logo.png": "5ff8",
	"./STN_logo_grey.png": "dce7",
	"./SYKE_logo.svg": "3aed",
	"./SYKE_logo_grey.svg": "e000",
	"./TUNI_logo.svg": "eff5",
	"./TUNI_logo_grey.svg": "ab5e",
	"./VTT_logo.svg": "d192",
	"./VTT_logo_grey.svg": "bf90d",
	"./cb_K.svg": "4d84",
	"./cb_K2.svg": "fc9a",
	"./cb_K3.svg": "9154",
	"./cb_cookbook.svg": "013d",
	"./cb_keinot.svg": "e286",
	"./cb_kohteet.svg": "85ec",
	"./cb_lens.svg": "4c84",
	"./cb_logo.svg": "238b",
	"./cb_logo_blue 2.svg": "afa5",
	"./cb_logo_blue.svg": "4133",
	"./cb_logo_grey.svg": "be86",
	"./example-img.jpg": "b9ce",
	"./hero/hero_1.jpg": "4204",
	"./hero/hero_2.jpg": "6911",
	"./hero/hero_3.jpg": "88d8",
	"./hero/hero_4.jpg": "6706",
	"./hero/hero_5.jpg": "9938",
	"./hero/hero_6.jpg": "99ba",
	"./hero/hero_7.jpg": "3dd9",
	"./hero/hero_8.jpg": "4681",
	"./means_bg.svg": "67a5",
	"./means_bg_nodeweb.svg": "e83e",
	"./means_categories.svg": "9924",
	"./tausta.jpg": "d409"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";